(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cc-angle-base"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.ccAngleScrollInit) return;
    window.ccAngleScrollInit = true;
    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[data-cc-scroll]');
      if (!link) return;
      var hash = link.getAttribute('href') || '';
      if (hash.charAt(0) !== '#' || hash.length < 2) return;
      var target = document.getElementById(hash.slice(1));
      if (!target) return;
      event.preventDefault();
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
